import { OPEN_MODAL, CLOSE_MODAL } from './actions';
import * as m from './modals';

const initialState = {
  // estas props deben coincidir con los valores de las constantes del archivo modals.js
  [m.MODAL_MANAGE_BULK_UPDATE]: false,
  [m.MODAL_MANAGE_BULK_UPDATE_CONFIRMATION]: false,
  [m.MODAL_RUN_USER_AGENT]: false,
  [m.MODAL_RUN_CLOUD_AGENT]: false,
  [m.MODAL_UPGRADE_LICENSE]: false,
  [m.MODAL_AGENT_TOKEN]: false,
  [m.MODAL_AGENT_CREATE]: false,
  [m.MODAL_SCHEDULE_CREATE_EDIT]: false,
  [m.MODAL_WORKSPACE_CREATE_EDIT]: false,
  [m.MODAL_WORKSPACE_CREATE]: false,
  [m.MODAL_EVIDENCE]: false,
  [m.MODAL_JIRA]: false,
  [m.MODAL_JIRA_TEMPLATE]: false,
  [m.MODAL_NEW_JIRA_TEMPLATE]: false,
  [m.MODAL_SEND_TO_JIRA]: false,
  [m.MODAL_PROJECTS_CREATE_EDIT]: false,
  [m.MODAL_PROJECTS_DELETE]: false,
  [m.MODAL_PROJECTS_SHOW_ERROR]: false,
  [m.MODAL_REDIRECT_CONFIRMATION]: false,
  [m.MODAL_APPLY_TEMPLATE]: false,
  [m.MODAL_VULNS_NOT_CONFIRMED]: false,
  [m.MODAL_SEND_TO_SERVICENOW]: false,
  [m.MODAL_SEND_TO_GITLAB]: false,
  [m.MODAL_SEND_TO_WHD]: false,
  [m.MODAL_UPGRADE_LICENSE_NOTIFICATION]: false,
  [m.MODAL_UPGRADE_LICENSE_SIDEBAR]: false,
  [m.MODAL_CLOUD_ONLY_SCANNERS]: false,
  [m.MODAL_MOVE_VULN_HOST]: false,
  [m.MODAL_MOVE_ASSET_WS]: false,
  [m.MODAL_SCHEDULE_DELETE]: false,
  [m.MODAL_AGENT_DETAIL]: false,
  [m.MODAL_AGENT_TRIGGER_WARNING]: false,
  [m.MODAL_TAGS_IN_AGENTS]: false,
  [m.MODAL_SCHEDULE_DETAIL]: false,
  [m.MODAL_AGENT_EXECUTOR_DETAIL]: false,
  [m.MODAL_SEND_TO_SERVICE_DESK]: false,
  [m.MODAL_SCHEDULER_INACTIVE_WARNING]: false,
  [m.MODAL_ROLE_CREATE_EDIT]: false,
  [m.MODAL_ROLES_DELETE_CONFIRMATION]: false,
  [m.MODAL_REPORT_WARNING_LOGO]: false,
  [m.MODAL_EMAIL_VERIFICATION]: false,
  [m.MODAL_EMAIL_VERIFICATION_MESSAGE]: false,
  [m.MODAL_WORKSPACE_GROUPING_CONFIRM]: false,
  [m.MODAL_VULNS_CREATE_MANUAL_GROUPING]: false,
  [m.MODAL_VULNS_ADD_TO_MANUAL_GROUPING]: false,
  [m.MODAL_SET_REPORT_TEMPLATE_NAME]: false
};

function modals (state = initialState, action) {
  switch (action.type) {
    case OPEN_MODAL: {
      return {
        ...state,
        [action.payload]: true
      };
    }

    case CLOSE_MODAL: {
      return {
        ...state,
        [action.payload]: false
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default modals;
